import React from "react";
import { TextField, Tooltip } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopTimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useClipsStore } from "./ClipsStore/clipsStore";
import { useNavigate } from "react-router-dom";
import {
  TIME_FILTERS_SAME_DATE_TOOLTIP,
  timeFiltersSameDateTooltipProps,
} from "../../common/timeFiltersSameDateTooltip";

export const EndTimeDropDownSMTP = () => {
  const {
    userFiltersSMTP,
    setUserFiltersSMTP,
    timeFiltersDisabledSMTP,
    getDownloadURLSMTP,
  } = useClipsStore();

  const navigate = useNavigate();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Tooltip
        title={TIME_FILTERS_SAME_DATE_TOOLTIP}
        disableHoverListener={!timeFiltersDisabledSMTP}
        disableFocusListener={!timeFiltersDisabledSMTP}
        disableTouchListener={!timeFiltersDisabledSMTP}
        {...timeFiltersSameDateTooltipProps}
      >
        <span style={{ display: "inline-block" }}>
          <DesktopTimePicker
            label="End Time"
            value={userFiltersSMTP.end_time ? userFiltersSMTP.end_time : null}
            onChange={(newValue) => {
              setUserFiltersSMTP((previousState: any) => ({
                ...previousState,
                end_time: newValue,
              }));
              getDownloadURLSMTP(navigate);
            }}
            disabled={timeFiltersDisabledSMTP}
            renderInput={(params) => (
              <TextField {...params} autoComplete="off" sx={{ width: 150 }} />
            )}
          />
        </span>
      </Tooltip>
    </LocalizationProvider>
  );
};
